export default __webpack_public_path__ + "static/media/e-registro-login-bg-bright.e10a17b0.jpg";